import { useCallback } from 'react';

import copy from 'copy-to-clipboard';

import { useAppDispatch } from 'src/app/store/hooks';
import { show } from 'src/common/primitives/Toast/toast.slice';

// TODO: move to common

export function useCopyText() {
  const dispatch = useAppDispatch();

  return useCallback(
    (text: string) => {
      const result = copy(text);
      if (result) {
        dispatch(
          show({
            title: 'Text copied to clipboard',
            type: 'success',
          })
        );
      } else {
        dispatch(
          show({
            title: 'Failed to Copy',
            description:
              'Your browser does not support copying to the clipboard, please copy manually.',
            type: 'error',
          })
        );
      }
    },
    [dispatch]
  );
}
